import { ProductActivationStatusResponse } from '@oy/types';
import axios, { AUTH_PREFIX } from 'src/clients/axios';

export const PRODUCT_E_CATALOGUE_URL = `${AUTH_PREFIX}/product-catalogue/list`;

export const getProductStatusActivation = (onlyProduction = false) => {
  return axios.request<ProductActivationStatusResponse>({
    method: 'get',
    url: `${AUTH_PREFIX}/products/status`,
    onlyProduction,
  });
};

export const getECatalogueList = () => {
  return axios.request({
    method: 'get',
    url: PRODUCT_E_CATALOGUE_URL,
  });
};

export const requestProduct = (productName: string) => {
  return axios.request({
    method: 'post',
    url: `${AUTH_PREFIX}/products/request`,
    data: { product: productName },
    onlyProduction: true,
  });
};
